import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LevelProgressDto } from '../types/LevelProgressDto';
import { PropertyLevelProgressDto } from '../types/PropertyLevelProgressDto';
import { UtilsService } from '../utils.service';
import { OeAppService } from '../oe-app.service';
import { OeAppPersonService } from '../oe-app-person.service';

@Injectable({
  providedIn: 'root',
})
export class LevelProgressService {
  levelProgress: BehaviorSubject<LevelProgressDto> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  get unitLevelProgress$(): Observable<PropertyLevelProgressDto> {
    return this.levelProgress.asObservable().pipe(
      filter(UtilsService.isNotNull),
      map((level: LevelProgressDto) => {
        return {
          percent: level.unitProgressPercent,
          taken: level.unitTaken,
          required: level.unitRequired,
        };
      })
    );
  }

  get lessonLevelProgress$(): Observable<PropertyLevelProgressDto> {
    return this.levelProgress.asObservable().pipe(
      map((level: LevelProgressDto) => {
        return {
          percent: level.lessonProgressPercent,
          taken: level.lessonTaken,
          required: level.lessonRequired,
        };
      })
    );
  }

  get liveClassLevelProgress$(): Observable<PropertyLevelProgressDto> {
    return this.levelProgress.asObservable().pipe(
      map((level: LevelProgressDto) => {
        if (!level) {
          return {
            percent: 0,
            taken: 0,
            required: 0,
          };
        }
        return {
          percent: level.liveClassProgressPercent,
          taken: level.liveClassTaken,
          required: level.liveClassRequired,
        };
      })
    );
  }

  get practiceLevelProgress$(): Observable<PropertyLevelProgressDto> {
    return this.levelProgress.asObservable().pipe(
      filter(UtilsService.isNotNull),
      map((level: LevelProgressDto) => {
        return {
          percent: level.practiceProgressPercent,
          taken: level.practiceTaken,
          required: level.practiceRequired,
        };
      })
    );
  }

  get levelProgress$(): Observable<LevelProgressDto> {
    return this.levelProgress.asObservable();
  }

  getShowMidLevelTest() {
    const url = `${this.oeAppService.oeProgressServiceHost}/v1/mid-level-tests?personId=${this.oeAppPersonService.id}`;
    return this.http.get<{ showMidLevelTest: boolean }>(url).pipe(map(({showMidLevelTest}) => showMidLevelTest));
  }

  fetchLevelProgress(): Observable<LevelProgressDto> {
    const url = `${this.oeAppService.oeProgressServiceHost}/v1/progresses?personId=${this.oeAppPersonService.id}&contactId=${this.oeAppPersonService.contactId}`;
    return this.http.get<LevelProgressDto>(url).pipe(map((resp) => this.removeDecimalsInResponse(resp)));
  }

  updateLevelProgress(): void {
    this.fetchLevelProgress().subscribe((resp) => this.levelProgress.next(resp));
  }

  removeDecimalsInResponse(resp: LevelProgressDto) {
    if (!resp) {
      return;
    }
    // Getting rid of decimals
    resp.lessonProgressPercent = Math.floor(resp.lessonProgressPercent);
    resp.unitProgressPercent = Math.floor(resp.unitProgressPercent);
    resp.practiceProgressPercent = Math.floor(resp.practiceProgressPercent);
    resp.liveClassProgressPercent = Math.floor(resp.liveClassProgressPercent);
    resp.levelProgressPercent = Math.floor(resp.levelProgressPercent);
    return resp;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/level-progress/level-progress.service.ts